import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-tarjetas',
  templateUrl: './tarjetas.component.html',
  styleUrls: ['./tarjetas.component.css']
})
export class TarjetasComponent implements OnInit {

  constructor(public modalCtrl: ModalController) { }

  ngOnInit(): void {
  }

  closeModal() { 
    this.modalCtrl.dismiss()
  }

}
